import { getMenuCategoriesByLocalId } from "../../../../../crud/menu_api/categories";
import {getMenusByLocalId} from "../../../../../crud/menu_api/menus";
import { getAllItemsByLocalId } from "../../../../../crud/menu_api/items";

export const getCategoryOptions = async () => {
    // it should return a map of workstation names and ids
    // get the local id from the user context
      const userContext = localStorage.getItem('user');
      const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
      const response = await getMenuCategoriesByLocalId (localId);
      if (response) {
        const data = response.data;
        if (data) {
          const categories:any[] = data.map((category:any) => {
            return {
              id: category.category_id,
              name: category.category_name,
            };
          });
          return categories;
        }
      }
      return [];
    };

export const getMenuOptions = async () => {
    // it should return a map of workstation names and ids
    // get the local id from the user context
      const userContext = localStorage.getItem('user');
      const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
      const response = await getMenusByLocalId(localId);
      if (response) {
        const data = response.data;
        if (data) {
          const menus:any[] = data.map((menu:any) => {
            return {
              id: menu.menu_id,
              name: menu.menu_name,
            };
          });
          return menus;
        }
      }
      return [];
    }

export const getItemOptions = async () => {
    // it should return a map of workstation names and ids
    // get the local id from the user context
      const userContext = localStorage.getItem('user');
      const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
      const response = await getAllItemsByLocalId(localId);
      if (response) {
        const data = response.data;
        if (data) {
          const items:any[] = data.map((item:any) => {
            return {
              id: item.item_id,
              name: item.item_name,
            };
          });
          return items;
        }
      }
      return [];
    }

// create optionMap. It receives an array of objects {id:int, name:string} and returns a map of id and name: 
// {id: name, ...}

export const createOptionMap = (options:any[]) => {
    return options.reduce((acc, option) => {
      acc[option.id] = option.name;
      return acc;
    }, {});
  }